module.exports = __webpack_public_path__ + "img/gaoshouyi.6c16e122.png";